'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingPropTypes = exports.spacing = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spacing = {
  // margin
  gap: function gap(_ref) {
    var theme = _ref.theme;
    return '\n    margin: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapBottom: function gapBottom(_ref2) {
    var theme = _ref2.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapLeft: function gapLeft(_ref3) {
    var theme = _ref3.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapNone: function gapNone() {
    return 'margin: 0;';
  },

  gapRight: function gapRight(_ref4) {
    var theme = _ref4.theme;
    return '\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapTop: function gapTop(_ref5) {
    var theme = _ref5.theme;
    return '\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapX: function gapX(_ref6) {
    var theme = _ref6.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapY: function gapY(_ref7) {
    var theme = _ref7.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },
  // padding
  pad: function pad(_ref8) {
    var theme = _ref8.theme;
    return '\n    padding: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padBottom: function padBottom(_ref9) {
    var theme = _ref9.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padLeft: function padLeft(_ref10) {
    var theme = _ref10.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padNone: function padNone() {
    return 'padding: 0;';
  },

  padRight: function padRight(_ref11) {
    var theme = _ref11.theme;
    return '\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padTop: function padTop(_ref12) {
    var theme = _ref12.theme;
    return '\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padX: function padX(_ref13) {
    var theme = _ref13.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padY: function padY(_ref14) {
    var theme = _ref14.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  }
};

var spacingPropTypes = {
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.spacing = spacing;
exports.spacingPropTypes = spacingPropTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/modifiers/spacing.js
// module id = 714
// module chunks = 2